export const defaultPath = process.env.REACT_APP_LOOTBALL_URL ? 
    `${process.env.REACT_APP_LOOTBALL_URL}`
: 
    'https://loot-back.prod.optimiser.website/'